const headers = (token) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
});

export const getCronJobs = async (token) => {
  const response = await fetch(`${window.constants.api_url}/cron-logs/jobs`, {
    method: "GET",
    headers: headers(token),
  });
  return response.json();
};

export const getCronRuns = async (token, body) => {
  const response = await fetch(`${window.constants.api_url}/cron-logs`, {
    method: "POST",
    headers: headers(token),
    body: JSON.stringify(body),
  });
  return response.json();
};
